import Vue from "vue"

Vue.filter("number", number => new Intl.NumberFormat().format(number));
Vue.filter("currency", (number,lang) => new Intl.NumberFormat(lang + '-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 }).format(Math.round(number / 1000)));
Vue.filter("currencyFull", (number,lang) => new Intl.NumberFormat(lang + '-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 }).format(number));
Vue.filter("percent", (number,lang) => new Intl.NumberFormat(lang + '-CA', { style: 'percent', maximumFractionDigits: 0 }).format(number/100));
